import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkExperienceService {

  constructor(private http: HttpClient) { }

  saveExperience(payload){
    return this.http.post<any>(`${environment.apiUrl}/v1/experience`, payload);
  }

  getIndustrySectors(){
    return this.http.get(`${environment.apiUrl}/v1/industry`);
  }

  getJobCategories(){
    return this.http.get(`${environment.apiUrl}/v1/job-title-category`);
  }

  getJobCategoriesList(){
    return this.http.get(`${environment.apiUrl}/v1/job-title-category/list`);
  }

  getExperience(){
    return this.http.get<any>(`${environment.apiUrl}/v1/experience`);
  }

  updateExperience(payload){
    return this.http.put<any>(`${environment.apiUrl}/v1/experience`, payload);
  }

  deleteExperience(id){
    return this.http.delete<any>(`${environment.apiUrl}/v1/experience/`+id);
  }

}
